import React, { Suspense, lazy } from 'react';

import Box from '@mui/material/Box';
import { useLocation } from 'wouter';

import Breadcrumbs from './Inside/Breadcrumbs';
import Content from './Inside/Content';
import SideNavbar from './Inside/SideNavbar';

const ClaimCommentsPanel = lazy(
  () => import('../pages/ClaimsTool/ClaimComments/ClaimCommentsPanel'),
);

const CLAIM_ROUTE_PATTERN = /^\/claims-tool\/claim\/([^/]+)/;

// the layout that all inner pages are expected to use
const InsideLayout = ({ children, breadcrumbs = true, contentPadding }) => {
  const [location] = useLocation();
  const claimRouteMatch = location.match(CLAIM_ROUTE_PATTERN);
  const claimId = claimRouteMatch
    ? decodeURIComponent(claimRouteMatch[1])
    : null;

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <SideNavbar />
      <Content contentPadding={contentPadding}>
        {breadcrumbs && <Breadcrumbs />}
        {children}
      </Content>
      {claimId && (
        <Suspense fallback={null}>
          <ClaimCommentsPanel key={claimId} claimId={claimId} />
        </Suspense>
      )}
    </Box>
  );
};

export default InsideLayout;
